export default __webpack_public_path__ + "static/media/pdf.dbab2182.png";